<template>
  <div class="kk-styles_menu">
    <nav-header :title="$t('sidebar.styles.title')"></nav-header>
    <!-- Body -->
    <div class="kk-styles_menu__tree">
      <custom-accordion
        v-for="(item, index) in stylesMenu"
        :id="index"
        :key="index"
        :is-open="item.isOpen"
        @clicked="clicked"
      >
        <template #titleSlot>
          <styles-title :title="item.title" :icon="item.icon" :is-open="item.isOpen" />
        </template>
        <component :is="allComponents[index]" />
      </custom-accordion>
    </div>
  </div>
</template>
<script>
import StylesTitle from "./StylesTitle.vue";
import NavHeader from "../RedZoneHeader.vue";
import CustomAccordion from "../../../commons/CustomAccordion.vue";
import Styles from "./Styles.vue";
import NumberFormat from "./NumberFormat.vue";
import EditStyle from "./EditStyle.vue";
export default {
  components: {
    NavHeader,
    CustomAccordion,
    StylesTitle,
    Styles,
    NumberFormat,
    EditStyle,
  },
  data() {
    return {
      stylesMenu: [
        {
          title: this.$t("sidebar.styles.menu.styles"),
          icon: "icon-plus",
          isOpen: false,
        },
        {
          title: this.$t("sidebar.styles.menu.templates"),
          isOpen: false,
        },
        {
          title: this.$t("sidebar.styles.menu.advanced"),
          isOpen: false,
        },
      ],
      allComponents: ["Styles", "NumberFormat", "EditStyle"],
    };
  },
  methods: {
    clicked(index) {
      this.stylesMenu[index].isOpen = !this.stylesMenu[index].isOpen;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/variables.less";
.kk-styles_menu {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  &__tree {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-top: 0.4rem;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
